module.exports = "/_next/static/images/Randy_Mantione-358954ffa89d5fd606bc993714a74283.webp";